export { default } from './ProfilePage'



// WEBPACK FOOTER //
// ./src/App/ProfilePage/index.js